import "@ant-design/v5-patch-for-react-19";
import { createRoot } from "react-dom/client"; // ✅ Note this change
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import ErrorBoundary from "./components/ErrorBoundary";

const container = document.getElementById("root");
const root = createRoot(container); // ✅ New root creation
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);
